import React from 'react';
import PropTypes from 'prop-types';
import { ZCDIcon } from '@zencity/common-ui';

function EmptyResults(props) {
  const { hasResponses } = props;

  return (
    <div className="engage-results-question-empty">
      <ZCDIcon name="info" />
      {hasResponses
        ? 'No responses to display. Adjust the filter criteria.'
        : 'No results have been collected for this question.'}
    </div>
  );
}

EmptyResults.propTypes = {
  hasResponses: PropTypes.bool.isRequired,
};

export default EmptyResults;
